module.exports = __webpack_public_path__ + "img/huoban4.2fae67f8.png";